<template>
<div class="container">
  <div class="title">
    <span>视觉华荣</span>
<!--    <span class="con-span">更多></span>-->
  </div>
  <!-- <img :src="img[currIndex]" alt=""> -->
  <el-carousel>
    <el-carousel-item v-for="(item, index) in img" :key="index">
      <img :src="item" @click="toList(index)"/>
    </el-carousel-item>
  </el-carousel>
  <!-- <div class="isActive">
    <ul>
      <li v-for="(item,index) in getCyList"
      :key="index"
      @mouseover="chang(index)"
      @mouseleave="end1"
          @click="toDetail(item.id)"
          :class="currIndex==index?'Active':''"
      >
        <div class="active" >{{item.name}}</div>
      </li>
    </ul>
  </div> -->
</div>
</template>

<script>
export default {
  name: "Qiecut",
  data(){
    return{
      currIndex:0,
      img:[]
    }
  },
  props:{
    getCyList:{
      type:Array
    }
  },
  watch:{
    getCyList:function (){
      for (let i=0;i<this.getCyList.length;i++)
      {
        if (this.getCyList[i].thumbnail) {
          this.img.push(this.getCyList[i].thumbnail)
        }
      }
    }
  },
  methods:{
    toList (index) {
      const id = this.getCyList[index].id
      this.$router.push(`/news/${id}`)
    },
    chang(index){
      this.currIndex=index
    },
    end1(){
      this.currIndex=0
    },
    toDetail(id){
      this.$router.push(`/news/${id}`)
}
  },

}
</script>

<style scoped>
.container{
  background-color: white;
  width: 395.5px;
  height: 325.67px;
}
.title{
  display: flex;
  justify-content: space-between;
  position: relative;
  line-height: 30px;
  color: #2574c2;
  margin: 0 10px;
  font-size: 18px;
  padding: 10px 0 0 0;
  border-bottom: 1px solid #d0d0d0;
  font-weight: bold;
}
.con-span{
  position: absolute;
  right: 10px;
  cursor: pointer;
  color: #303133;
  font-weight: normal;
  font-size: 14px;
}
img{
  width: 93%;
  padding: 5px 10px;
  height: 260px;
}
.isActive{
  display: flex;
  /*margin-top: 20px;*/
  /*margin-bottom: 20px;*/
}
.isActive ul{
  width: 100%;
 padding: 20px 0 0 10px;
  margin: 0;
}
li{
  list-style-type: none;
  width: 18%;
  font-size: 12px;
  display: inline-block;
  background-color: rgb(242, 242, 242);
  /*margin-top: 5px;*/
  /*margin-right: 7px;*/
  border: 2px solid #ffffff;
  cursor: pointer;
}
/*.isActive li:hover{*/
/*  background-color: #2574c2;*/
/*  color: white;*/
/*}*/
.Active{
  background-color: #2574c2;
  color: white;
}
.active{
  text-align: center;
  margin-bottom: 10px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Qiecut.vue